import { render, staticRenderFns } from "./level1.vue?vue&type=template&id=ef789b32&"
import script from "./level1.vue?vue&type=script&lang=ts&"
export * from "./level1.vue?vue&type=script&lang=ts&"
import style0 from "./level1.vue?vue&type=style&index=0&id=ef789b32&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports